import React from 'react';
import helpbid1 from '../../assets/images/help-bid-img.png';
import helpbid2 from '../../assets/images/help-bid-img2.png';

function HelpBid(){
    return(
        <div className="help-bid pc-p-6 secondary-background">
        <div className="container-fluid px-5">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="side-img">
                        <img src={helpbid1} alt="Help Bid" />
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="help-bid-content">
                        <div className="primary-heading color-light">
                            <h3 className="mb-4">Help Our Bid</h3>
                            <p className="text-justify">
                                "Empower your project with our ChatGPT-powered expertise. Our
                                tailored solutions stand out, promising efficient timelines
                                and optimal budget utilization. Leverage our team's proven
                                track record, crafting compelling proposals and addressing
                                client concerns adeptly. Elevate your bid to secure success
                                with innovation and precision."
                            </p>
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-md-6 col-12">
                                    <p className="text-justify">
                                        "Empower your project with our ChatGPT-powered expertise.
                                        Our tailored solutions stand out, promising efficient
                                        timelines and optimal budget utilization. Leverage our
                                        team's proven track record, crafting compelling proposals
                                        and addressing client concerns adeptly.
                                    </p>
                                </div>
                                <div className="col-lg-6 col-md-6 col-12">
                                    <div className="side-img">
                                        <img src={helpbid2} alt="Help Bid" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default HelpBid;